import React from "react";

const BankDetails = () => {
  return (
    <section className="grid-section">
      <div className="grid-container">
        <h2>Bank Details is not currently available.</h2>
      </div>
    </section>
  );
};

export default BankDetails;
